module.exports = "https://trybtryb-legacy.web.app/img/input-info.e98f932f.svg";